export default __webpack_public_path__ + "static/media/ca-foundation_accounts_youngminds.9c9fa9a1.png";